import { render, staticRenderFns } from "./the-header-navigation.vue?vue&type=template&id=5e63933e&"
import script from "./the-header-navigation.vue?vue&type=script&lang=js&"
export * from "./the-header-navigation.vue?vue&type=script&lang=js&"
import style0 from "./the-header-navigation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports